import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: 'Auth Codes',
	url: '/admin/auth_codes',
	icon: 'dashboard'
}];

export default class Auth_Codes extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>

				<Collections.AuthCodes/>

			</div>


		)
	}
}